import React, { useEffect } from "react";
import { makeStyles, Box, Link } from "@material-ui/core";
import { remCalc } from "../../../utils/helpers";
import PricingHeader from "./PricingHeader";
import FadeContainer from "./FadeContainer";
import { Link as RouterLink } from "react-router-dom";
import SinglePlan from "./SinglePlan";
import { connect } from "react-redux";
import { plans } from "../../data/plans";
import mixpanelWrapper from "../../../utils/mixpanel";

const useStyles = makeStyles(theme => ({
  content: {
    marginTop: remCalc(110),
    display: "inline-flex",
    justifyContent: "center",
    position: "relative",
    textAlign: "left",
    paddingBottom: theme.spacing(6.5)
  },
  cancelLink: {
    color: "#4D4D50",
    fontSize: "0.75rem",
    lineHeight: "0.875rem",
    textDecoration: "underline",
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1.5)
  }
}));

function SelectPlan({
  open,
  handleClose,
  setActiveModal,
  currency,
  plan,
  paymentMethod,
  subscriptionStatus
}) {
  const classes = useStyles();

  // Close vehicles dialog if open
  useEffect(() => {
    setActiveModal("");
  }, [setActiveModal]);

  useEffect(() => {
    mixpanelWrapper.track("Plan View");
  }, []);

  return (
    <FadeContainer open={open}>
      <PricingHeader
        title={
          paymentMethod
            ? "Plans and pricing"
            : "Choose the right plan for your business"
        }
        handleClose={handleClose}
      />
      <Box display="block" textAlign="center" overflow="auto" flexGrow="1">
        <Box className={classes.content}>
          <SinglePlan
            currencyLoaded={currency.loaded}
            // popular
            active={plan.type === plans[0].name}
            subscriptionStatus={subscriptionStatus}
            price={`${currency.symbol}39`}
            title={plans[0].title}
            plan={plans[0]}
            subtitle={plans[0].subtitle}
            checkCircleItems={[
              { text: "Unlimited stops" },
              { text: "Web + driver app" },
              { text: "Route optimization" },
              { text: "Unlimited vehicles" },
              { text: "Spreadsheet upload" },
              { text: "Completion notes" },
              { text: "Priority email support" },
              { text: "Live chat support" }
            ]}
            plusCircleItems={[ ]}
          />
          <SinglePlan
            currencyLoaded={currency.loaded}
            active={plan.type === plans[1].name}
            subscriptionStatus={subscriptionStatus}
            price={`${currency.symbol}59`}
            title={plans[1].title}
            plan={plans[1]}
            subtitle={plans[1].subtitle}
            checkCircleItems={[
              { text: "Everything in Small Business, plus:", style: "bold" }
            ]}
            plusCircleItems={[
              { text: "Track drivers live on a map" },
              { text: "Edit routes in real-time" },
              { text: "Predictive ETAs and alerts" },
              { text: "Collect signatures and take photos" },
              { text: "Delivery tracking app for customers" },
              { text: "SMS and email notifications" },
              { text: "API integration" }
            ]}
          />
          <SinglePlan
            currencyLoaded={currency.loaded}
            active={plan.type === "enterprise"}
            title={"Enterprise"}
            subtitle={
              "Ideal for enterprise businesses or those with complex needs."
            }
            checkCircleItems={[
              { text: "Everything in Business, plus:", style: "bold" }
            ]}
            plusCircleItems={[
              { text: "Enterprise level support" },
              { text: "Dedicated success manager" },
              { text: "Up to 16 hours training" },
              { text: "Advanced branding" },
              { text: "Phone support" }
            ]}
          />
          {paymentMethod && (
            <Link
              component={RouterLink}
              to="/payment/cancel-subscription"
              className={classes.cancelLink}
            >
              Request account cancellation
            </Link>
          )}
        </Box>
      </Box>
    </FadeContainer>
  );
}

const mapStateToProps = state => ({
  paymentMethod: state.account.payment,
  subscriptionStatus:
    (state.auth.userData.organisationSite &&
      state.auth.userData.organisationSite.organisation.subscription_status) ||
    ""
});

export default connect(mapStateToProps)(SelectPlan);
